import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { GetImageReportUploadContent, GetImageReportUploadContentResponse } from "../../api/dtos";
import { useGet } from "@ngt/opms";


const getData = (response?: SWRResponse<GetImageReportUploadContentResponse, GetImageReportUploadContentResponse>) => ({ ...response?.data, responseStatus: undefined });
const getError = (response?: SWRResponse<GetImageReportUploadContentResponse, GetImageReportUploadContentResponse>) => (response?.error ?? response?.data)?.responseStatus;

const useGetImageReportUploadContent = (query: Partial<GetImageReportUploadContent> | undefined, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) return undefined;

        return () => {
            return new GetImageReportUploadContent(query);
        }
    }, [query]);

    return useGet(request, { getData, getError }, configuration);
}


export default useGetImageReportUploadContent;